<template>
    <div>
        <div class="text-left">
            <h3 class="mb-3">{{$t('cal_Fibonacci')}}</h3>
            <p>{{$t('cal_fibo_txt')}}</p>
        </div>
        <div class="verticallyTab mt-5">
			<p v-if="message != ''" style="color:red">{{message}}</p>
            <div class="bottomTab">
                <div class="stepForm-contact mt-5"> 
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <div class="d-flex align-items-center mb-3">
                                    <label class="customRadio-button m-0 mr-2">{{$t('cal_fibo_Uptrend')}}
                                        <input type="radio" class="form-control" name="trend" value="U" v-model="trend" v-validate="'required'"  :class="{ 'is-invalid': submitted && errors.has('trend') }">
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="customRadio-button m-0">{{$t('cal_fibo_Downtrend')}}
                                        <input type="radio" class="form-control" name="trend" value="D" v-model="trend" v-validate="'required'"  :class="{ 'is-invalid': submitted && errors.has('trend') }">
                                        <span class="checkmark"></span>
                                    </label>
									<p class="error" v-if="submitted" v-for="error in errors.collect('trend')">{{$t('cal_fibo_Field_req')}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-8">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text"  class="float-field form-control" v-model="B" v-validate="'required'" name="B" :class="{ 'is-invalid': submitted && errors.has('B') }">
                                <label class="float-label">{{$t('cal_fibo_High')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('B')">{{$t('cal_fibo_Field_req')}}</p>
                            </div>
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text"  class="float-field form-control" v-model="A" v-validate="'required'" name="A" :class="{ 'is-invalid': submitted && errors.has('A') }">
                                <label class="float-label">{{$t('cal_fibo_Low')}} </label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('A')">{{$t('cal_fibo_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper">
                                <a href="#" class="common_btn" v-on:click.prevent="getFib()">{{$t('cal_fibo_Now')}}</a>
                                 
                                <div class="table-responsive">
                                    <table class="table commodities-table fundingMethodstable  table-bordered table-striped mt-5 mb-5">
                                        <thead>
                                            <tr>
                                                <th colspan="3">{{$t('cal_fibo_Retracements')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="trend == 'D'">
                                            <tr>
                                                <td>{{$t('cal_fibo_Support')}} 1</td>
                                                <td>23.60%</td>
                                                 <td>{{p1}}</td>
                                                 
                                            </tr>
                                            <tr>
                                                <td>{{$t('cal_fibo_Support')}} 2</td>
                                                <td>38.20%</td>
                                                <td>{{p2}}</td>
                                                
                                            </tr>
                                            <tr>
                                                <td>{{$t('cal_fibo_Support')}} 3</td>
                                                <td>50%</td>
                                                <td>{{p3}}</td>
                                               
                                            </tr>
                                            <tr>
                                                <td>{{$t('cal_fibo_Support')}} 4</td>
                                                <td>61.80%</td>
                                                <td>{{p4}}</td>
                                                
                                            </tr>
                                            <tr>
                                                <td>{{$t('cal_fibo_Support')}} 5</td>
                                                <td>78.60%</td>
                                                 <td>{{p5}}</td>
                                                
                                            </tr>
                                            <!-- <tr>
                                                <td>S6</td>
                                                 <td>{{p6}}</td>
                                                <td>-</td>
                                            </tr> -->
                                        </tbody>

                                        <tbody v-if="trend == 'U'">
                                            <tr>
                                                <td>{{$t('cal_fibo_Support')}} 1</td>
                                                <td>23.60%</td>
                                                <td>{{p1}}</td>
                                                
                                            </tr>
                                            <tr>
                                                <td>{{$t('cal_fibo_Support')}} 2</td>
                                                <td>38.20%</td>
                                                <td>{{p2}}</td>
                                                
                                            </tr>
                                            <tr>
                                                <td>{{$t('cal_fibo_Support')}} 3</td>
                                                <td>50%</td>
                                                <td>{{p3}}</td>
                                                
                                            </tr>
                                            <tr>
                                                <td>{{$t('cal_fibo_Support')}} 4</td>
                                                <td>61.80%</td>
                                                <td>{{p4}}</td>
                                                
                                            </tr>
                                            <tr>
                                                <td>{{$t('cal_fibo_Support')}} 5</td>
                                                <td>78.60%</td>
                                                <td>{{p5}}</td>
                                                
                                            </tr>
                                            <!-- <tr>
                                                <td>R6</td>
                                                <td>{{p6}}</td>
                                                <td>-</td>
                                            </tr> -->
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'fibonacci',
        data() {
            return {
                "trend":'U',
                "A":0,
                "B":0,
                "p1":0,
                "p2":0,
                "p3":0,
                "p4":0,
                "p5":0,
                "p6":0,
				submitted : false,
				message : ''

            }
        },
        methods:{
            getFib(){
				const _that = this
                this.submitted = true;
				this.message = ''
                this.$validator.validate().then(valid => {
                    if (valid) {
						_that.B = parseFloat(_that.B)
						_that.A = parseFloat(_that.A)
						if(_that.B > _that.A){
							if(_that.trend == 'U'){
								_that.p1 = parseFloat(_that.B - ((_that.B-_that.A) * 0.236)).toFixed(2)
								_that.p2 = parseFloat(_that.B - ((_that.B-_that.A) * 0.382)).toFixed(2)
								_that.p3 = parseFloat(_that.B - ((_that.B-_that.A) * 0.5)).toFixed(2)
								_that.p4 = parseFloat(_that.B - ((_that.B-_that.A) * 0.618)).toFixed(2)
								_that.p5 = parseFloat(_that.B - ((_that.B-_that.A) * 0.786)).toFixed(2)
								// _that.p6 = _that.B - ((_that.B-_that.A) * 1.000)
							}
							if(_that.trend == 'D'){
								_that.p1 = parseFloat(_that.A + ((_that.B-_that.A) * 0.236)).toFixed(2)
								_that.p2 = parseFloat(_that.A + ((_that.B-_that.A) * 0.382)).toFixed(2)
								_that.p3 = parseFloat(_that.A + ((_that.B-_that.A) * 0.5)).toFixed(2)
								_that.p4 = parseFloat(_that.A + ((_that.B-_that.A) * 0.618)).toFixed(2)
								_that.p5 = parseFloat(_that.A + ((_that.B-_that.A) * 0.786)).toFixed(2)
								// _that.p6 = _that.B + ((_that.A-_that.B) * 1.000)
							}
						}else{
							_that.message = "Low value should be lower than high value"
						}
					}
				})
            }
        },
        computed: {


        },
        mounted() {

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/fibonacci.vue